<template>
    <v-chart
      class="line_chart"
      :option="options"
      :style="chartStyle"
      :loading="loading"
      :loadingOptions="lineLoadingOptions"
      @click="echartsClick"
      ref="chartRef"
    />
  </template>
  
  <script>
  import { 
    ref,
    watch
  } from "vue";
  import {
    getCampScoreV2
  } from "@/api";
  import {
    getCarScore as getCarScoreV22
  } from "@/api_drive";
  import { use } from "echarts/core";
  import { CanvasRenderer } from "echarts/renderers";
  import { LineChart,BarChart} from "echarts/charts";
  import {
    LegendComponent,
    TooltipComponent,
    GridComponent,
    ToolboxComponent,
  } from "echarts/components";
  use([
    CanvasRenderer,
    LineChart,
    BarChart,
    LegendComponent,
    TooltipComponent,
    GridComponent,
    ToolboxComponent,
  ]);
  import VChart from "vue-echarts";
  export default {
    props: {
      chartStyle: {
        type: Object,
        default(){
          return {
            width: "1200px",
            height: "300px",
          }
        },
      },
      node_id:{
        default:''
      },
      models:{
        default:[]
      },
      data:{
        default:null
      },
      route_type:{
        default:''
      }
  
      
    },
    components: {
      VChart,
    },
    setup(props,ctx) {
      const lineLoadingOptions = ref({
        text: "Loading…",
        color: "#4ea397",
        maskColor: "rgba(255, 255, 255, 0.4)",
      });
      const loading = ref(false);
      const chartRef = ref(null);
      const options = ref(null);
      let nodes = {};
      let node_childs = {};
      const getChartDataFn = ()=>{
        console.log(props.models)
        loading.value = true;
        if(props.node_id && props.models && props.models.length>0){
          let promise_list = props.models.map(item=>{
            return new Promise((resolve,reject)=>{
              let promiseFn = props.route_type == 'drive' ? getCarScoreV22 : getCampScoreV2;
              promiseFn({
                model_id: item.model_id,
                report_id: item.report_id,
                node_id:props.node_id,
              })
              .then((res) => {
                resolve(res);
              })
              .catch((res) => {
                reject(res);
              });
            })
          })
          let data = [];
          Promise.all(promise_list).then((values)=>{
            loading.value = false;
            if (values && values.length > 0) {
              for (let item of values) {
                if (item.code == 200) {
                  data.push(item.data);
                }
              }
              processDataFn(data);
            }
          })
        }
      }
      const setLineChartOptions = (legendName, lineName, lineValue) => {
        let options_data = {
          color:['#69a8f0', '#AEDAAE', '#b0d8f5', '#5cbe85', '#f2d0a7', '#e1b0bb', '#EAC0EA', '#fac858', '#ee6666'],
          grid: {
            show: true,
            backgroundColor: "rgba(250, 250, 250, .6)",
            borderColor: "rgba(255, 255, 255, 1)",
          },
          tooltip: {
            trigger: "axis",
            enterable: true,
            confine: true,
            backgroundColor: "rgba(37, 34, 69, 0.8)",
            transitionDuration: 1,
            padding: [20, 30, 17, 30],
            position: function (point) {
              // 固定在顶部
              return [point[0], "20%"];
            },
            textStyle: {
              color: "#fff",
              fontSize: 14,
              lineHeight: 16,
            },
            axisPointer: {
              type: 'shadow'
            },
          },
          legend: {
            data: legendName,
            left: "center",
            itemWidth: 11,
            itemHeight: 11,
            itemGap: 25,
            itemStyle: {
              fontSize: 12,
            },
          },
          xAxis: {
            triggerEvent: true,
            type: "category",
            boundaryGap: true,
            data: lineName,
            axisLine: {
              lineStyle: {
                // color: "#b9c2da",
                width: "1",
              },
            },
            axisTick: {
              alignWithLabel: true,
            },
            // nameLocation: "center",
            nameTextStyle: {
              color: "#404248",
              fontSize: 16,
            },
            axisLabel: {
              color:"#2192ff",
              fontSize: 14,
              padding: [0, 8],
              margin: 10,
              overflow: "breakAll",
              interval: 0,
            },
            offset: 10,
  
          },
          // axisTick:{
          //   alignWithLabel:true
          // },
          yAxis: {
            type: "value",
            axisLabel: {
              color: "#404248",
              fontSize: 12,
              padding: [0, 20, 0, 0],
              formatter: "{value} %",
            },
            splitLine: {
              lineStyle: {
                color: "#edf2fe",
              },
            },
            splitNumber: 5,
            // min: function (value) {
            //   return Math.floor(value.min / 10) * 10;
            // },
            // max: function (value) {
            //   return (Math.floor(value.max / 10) + 1) * 10 > 100
            //     ? 100
            //     : (Math.floor(value.max / 10) + 1) * 10;
            // },
            // interval: 10,
          },
          series: lineValue,
        };
        options.value = options_data;
        ctx.emit('loadEnd');
      };
      if(props.data){ // 如果传入了数据直接处理数据,如果没有再去请求数据
        processDataFn(props.data)
      }else{
        getChartDataFn();
      }
      // 处理数据的函数,接收一个数组
      const processDataFn = (data)=>{
        if (data && data.length > 0) {
          //横轴分类展示
          const lineName = [];
          // 车型分类展示
          const legendName = [];
          // 折线数值展示
          const lineValue = [];
  
          for (let [index, car] of props.models.entries()) {
            legendName.push({ name: car.model_name, icon: "rect" });
            const carLineValue = {
              name: car.model_name,
              // type: "line",
              type: "bar",
              data: [],
              symbol: "circle",
              symbolSize: 8,
              animation: true,
              label: {
                show: true,
                position:'top',
              },
              barMaxWidth:60,
              emphasis: {
                focus: 'series'
              },
              barWidth:25,
              // barGap: 0, //柱子之间的距离
              triggerLineEvent: true,
            };
            for (let node_item of data[index].list) {
              if (lineName.indexOf(node_item.node_name) < 0) {
                lineName.push(node_item.node_name);
                nodes[node_item.node_name] = node_item.node_id;
                node_childs[node_item.node_name] = node_item.child;
              }
              node_item.score_percentage = parseFloat((node_item.score / node_item.total_score) * 100).toFixed(1);
              // Number(
              //   ((node_item.score / node_item.total_score) * 100).toFixed(1)
              // );
  
              carLineValue.data.push({
                label: {
                  color: "#404248",
                  fontSize: 12,
                  fontWeight:600,
                  formatter: () => {
                    return node_item.score_percentage;// + "%"
                  },
                },
                emphasis: {
                  focus: 'series'
                },
                value: node_item.score_percentage,
                
              });
            }
            lineValue.push(carLineValue);
          }
          //   清除画布
          chartRef.value && chartRef.value.clear();
          setLineChartOptions(legendName, lineName, lineValue);
        }
      }
      const echartsClick = (params)=>{
        let node_id = 0;
        let node_name = "";
        let node_childs_arr = [];
        if (params.componentType == "xAxis") {
          node_id = nodes[params.value];
          node_name = params.value;
        } else if (params.componentType == "series") {
          node_id = nodes[params.name];
          node_name = params.name;
        }
        node_childs_arr = node_childs[node_name];
        ctx.emit('handel',{
          node_id,
          node_name,
          node_childs:node_childs_arr
        })
      }
      watch(()=>props.node_id,(new_val,old_val)=>{
        if(new_val!=old_val){
          getChartDataFn();
        }
      })
      watch(()=>props.models.length,()=>{
          getChartDataFn();
      })
      return {
        lineLoadingOptions,
        loading,
        echartsClick,
        chartRef,
        options
      };
    },
  };
  </script>
  
  <style>
  </style>